import Avatar1 from "./images/users/avatar-1.jpg";
import profileImage from "./images/users/avatar-1.jpg";
import logoSm from "./images/jlt-cabz-logo-header.webp";
import logoDark from "./images/jlt-cabz-logo-header.webp";
import logoIcon from "./images/jlt-cab-favicon.png";
import errorImagesvg from "./images/error.svg";
import defaultprofile from "./images/profile-img-default.png";
import playButton from "./images/play-button.png";
import blankProfile from "./images/blank-profile.webp";
import SigninPageBack from "./images/jlt-login-banner.jpg";
import DefultImage from "./images/DefultImage.png";
import Excel from "./images/excel.png";
import logoMeridian from "./images/logo-meridian.png";
import DefaultsImage from "./images/Chaitrashree-Royal-banquet.webp"
import MeridianFavicon from "./images/meridian-favicon.png"
const allImages = {
  Excel,
  blankProfile,
  playButton,
  defaultprofile,
  errorImagesvg,
  Avatar1,
  profileImage,
  logoSm,
  logoDark,
  SigninPageBack,
  DefultImage,
  logoIcon,
  logoMeridian,
  DefaultsImage,
  MeridianFavicon
};

export default allImages;
